import { useTranslation } from 'react-i18next';
import { RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';
import { REGIONAL_RISK_DISEASE_TAG, REGIONAL_RISK_DISEASE_TAG_ICON, REGIONAL_RISK_DISEASE_TAG_NAME } from '../../domain/tests-id.constants';
import { Container, Icon, Text } from './disease-tag.styles';
import { getDiseaseTranslationKey } from './disease-tag.utils';

interface DiseaseTagProps {
  riskLevel: RiskLevelEnum;
  diseaseName: string;
}

const DiseaseTag = ({ riskLevel, diseaseName }: DiseaseTagProps) => {
  const [t] = useTranslation();
  const hasNoRisk = riskLevel === RiskLevelEnum.NO_RISK;
  const hasLowRisk = riskLevel === RiskLevelEnum.LOW;

  if (hasNoRisk) {
    return null;
  }

  const translatedName = t(getDiseaseTranslationKey(diseaseName), { defaultValue: diseaseName });

  return (
    <Container $riskLevel={riskLevel} data-testid={REGIONAL_RISK_DISEASE_TAG}>
      {!hasLowRisk && <Icon $riskLevel={riskLevel} data-testid={REGIONAL_RISK_DISEASE_TAG_ICON} />}
      <Text $riskLevel={riskLevel} data-testid={REGIONAL_RISK_DISEASE_TAG_NAME}>
        {translatedName}
      </Text>
    </Container>
  );
};

export default DiseaseTag;
